/**
 * Returns the initials of a given name.
 *
 * @param name - The name to get the initials from.
 * @returns The initials of the name.
 *
 * @example
 * getAvatar('John Doe') // Returns 'JD'
 * getAvatar('A') // Returns 'A'
 * getAvatar('') // Returns ''
 */
export const getAvatar = (name: string = ''): string => {
  const avatarStr = (name_str: string): string => {
    const splitStr: string[] | undefined = name_str?.trim().split(' ')
    const firstChar = splitStr?.[0]?.charAt(0) ?? ''
    const avatar =
      splitStr?.length > 1
        ? firstChar + (splitStr?.[splitStr?.length - 1]?.charAt(0) ?? '')
        : firstChar + (splitStr?.[0]?.charAt(splitStr?.[0]?.length - 1) ?? '')
    return avatar?.toUpperCase() || ''
  }

  return Boolean(name) || (name && name?.trim())?.length < 3
    ? avatarStr(name)
    : 'AT'
}
